import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddAccessTypePageNew from "../../components/AccessType/AddAccessTypePageNew";



const AddAccessTypePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Access Type" link2="/accesstype" title="Add Access Type" />

        {/* AddUserLayer */}
        <AddAccessTypePageNew />


      </MasterLayout>
    </>
  );
};

export default AddAccessTypePage;
